import { render } from "./ProfileRingScore.vue?vue&type=template&id=3ea7e9cd&scoped=true"
import script from "./ProfileRingScore.vue?vue&type=script&lang=js"
export * from "./ProfileRingScore.vue?vue&type=script&lang=js"

import "./ProfileRingScore.vue?vue&type=style&index=0&id=3ea7e9cd&scoped=true&lang=css"

import exportComponent from "/var/www/matchmaker/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ea7e9cd"]])

export default __exports__